import React from 'react';
import {Redirect} from 'react-router';
import Loadable from 'components/Loadable';

const abProfile = {
  path: '/ab-profile',
  component: Loadable({
    loader: () => import('../views/ab-profile'),
  }),
  routes: [
    {
      exact: true,
      path: '/ab-profile',
      component: () => <Redirect to="/ab-profile/accreditation-body" />,
    },
    {
      exact: true,
      path: '/ab-profile/accreditation-body',
      component: Loadable({
        loader: () => import('../views/ab-profile/accreditation-body'),
      }),
    },
    {
      exact: true,
      path: '/ab-profile/office-directories',
      component: Loadable({
        loader: () => import('../views/ab-profile/office-directories'),
      }),
    },
  ],
};

export default abProfile;
